export const visit = {
    'meta': {
        'title': 'Wizyta w Centrum COLLIGO • Psychiatria dzieci i młodzieży, psychiatria osób dorosłych, psychoterapia, psychologia | COLLIGO',
        'description': 'Przedstawiamy ważne informacje dotyczące wizyty w Centrum Psychiatrii i Psychoterapii COLLIGO'
    },
    'url': {
        'address': '/wizyta/',
        'title': 'Wizyta w Centrum COLLIGO • Psychiatria dzieci i młodzieży, psychiatria osób dorosłych, psychoterapia, psychologia | COLLIGO',
        'name': 'Wizyta'
    },
    'opengraph': {
        'image': {
            'url': null,
            'width': 150,
            'height': 150,
            'alt': 'Jak przygotować się do wizyty w Centrum Psychiatrii i Psychoterapii COLLIGO'
        }
    }
}